import { t as createFetchClient } from "./createFetchClient-DlGCbltR.js";
// src/fetchClient/createOpenapiFetchClient.ts
const createOpenapiFetchClient = (defaultOptions) => createFetchClient(defaultOptions);
export { createOpenapiFetchClient as t };

//# sourceMappingURL=createOpenapiFetchClient-Bhz62MUE.js.map